module.exports = __webpack_public_path__ + "img/buttt2.05fea412.png";